import React from 'react';
import { LOGO_SRC } from '../layout/navConfig';
import './loader.css';

const Loader = () => {
  return (
    <div className='premium-loader-overlay' role="status" aria-live="polite">
      <div className='loader-card'>
        <img
          src={LOGO_SRC}
          alt=""
          aria-hidden="true"
          className='loader-logo'
        />
        <div className='loader-progress-track'>
          <div className='loader-progress-fill'></div>
        </div>
        {/* Optional text, user wanted minimal/cool */}
        <div className='loading-text'>Loading...</div>
      </div>
    </div>
  );
};

export default Loader;
